import { useMemo } from 'react';
import { useAssetUrl } from './useAsset';
import { useConfig } from './queries/useConfig';

const FAVICON_SIZES = [16, 32, 48, 180, 192];

export const useFavicons = () => {
  const { data: chatbotConfig } = useConfig();
  const getAssetUrl = useAssetUrl();

  return useMemo(() => {
    if (!chatbotConfig?.faviconId) return undefined;

    return FAVICON_SIZES.map((size) => ({
      size,
      url: getAssetUrl(chatbotConfig.faviconId, chatbotConfig.faviconCrop, size, 'png'),
      rel: size === 180 ? 'apple-touch-icon' : 'icon',
    }));
  }, [chatbotConfig?.faviconId, chatbotConfig?.faviconCrop, getAssetUrl]);
};
